import { render, staticRenderFns } from "./SelecionarInstumentoQuestionario.vue?vue&type=template&id=1fdb55b2&scoped=true"
import script from "./SelecionarInstumentoQuestionario.vue?vue&type=script&lang=js"
export * from "./SelecionarInstumentoQuestionario.vue?vue&type=script&lang=js"
import style0 from "./SelecionarInstumentoQuestionario.vue?vue&type=style&index=0&id=1fdb55b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdb55b2",
  null
  
)

export default component.exports